export default "__VITE_ASSET__CePXBOhU__"